<!-- fullscreen-alert.component.html -->
<div class="fullscreen-alert">
    <div class="alert-content">
      <h1>{{ message }}</h1>
      <button (click)="closeAlert()">Fechar</button>
    </div>
  </div>